if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        if (this.variantUnsub) {
          this.variantUnsub();
          this.variantUnsub = null;
        }
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            super.show(opener);
            this.loadCrossSell();
            this.initGallery();
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      /* Swipeable gallery (counter and arrows) and image swap when a colour or style is chosen. */
      initGallery() {
        const productInfo = this.modalContent.querySelector('product-info');
        /* The theme's own image swap loses track of the popup's renamed ids and leaves the
           first image stuck, so the popup handles variant images itself (showMedia below). */
        if (productInfo) productInfo.updateMedia = function () {};

        const list = this.modalContent.querySelector('.product__media-list');
        if (list) {
          const items = Array.from(list.children).filter(function (li) {
            return li.dataset && li.dataset.mediaId;
          });
          const gallery = list.closest('media-gallery') || list.parentElement;
          if (gallery && items.length > 1) {
            gallery.classList.add('wwp-qa-gallery');
            const count = document.createElement('span');
            count.className = 'wwp-qa-count';
            count.setAttribute('aria-hidden', 'true');
            const makeNav = function (cls, label, glyph, dir) {
              const b = document.createElement('button');
              b.type = 'button';
              b.className = 'wwp-qa-nav ' + cls;
              b.setAttribute('aria-label', label);
              b.innerHTML = glyph;
              b.addEventListener('click', function () {
                list.scrollBy({ left: dir * list.clientWidth, behavior: 'smooth' });
              });
              return b;
            };
            gallery.appendChild(makeNav('wwp-qa-nav--prev', 'Previous image', '&lsaquo;', -1));
            gallery.appendChild(makeNav('wwp-qa-nav--next', 'Next image', '&rsaquo;', 1));
            gallery.appendChild(count);
            const update = function () {
              const w = list.clientWidth || 1;
              const i = Math.min(Math.round(list.scrollLeft / w), items.length - 1);
              count.textContent = i + 1 + ' / ' + items.length;
            };
            list.addEventListener('scroll', function () {
              window.requestAnimationFrame(update);
            }, { passive: true });
            update();
          }
        }

        if (this.variantUnsub) this.variantUnsub();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            const v = data && data.variant;
            this.showMedia(v && v.featured_media && v.featured_media.id);
          });
        }
      }

      showMedia(mediaId) {
        if (!mediaId) return;
        const list = this.modalContent.querySelector('.product__media-list');
        if (!list) return;
        const suffix = '-' + mediaId;
        const target = Array.from(list.children).find(function (li) {
          return li.dataset && li.dataset.mediaId && li.dataset.mediaId.endsWith(suffix);
        });
        if (!target) return;
        const left = list.scrollLeft + target.getBoundingClientRect().left - list.getBoundingClientRect().left;
        list.scrollTo({ left: left, behavior: 'smooth' });
      }

      loadCrossSell() {
        const container = this.querySelector('.wwp-modal-crosssell');
        if (!container) return;
        const productId = container.dataset.productId;
        if (!productId) return;

        /* Shopify's recommendations data gives featured_image as a plain URL string
           (older code expected an object with .src, so no image was ever found).
           This reads either format, fixes protocol-relative URLs and asks for a small size. */
        const pickSrc = function (p) {
          let raw = '';
          const fi = p.featured_image;
          if (typeof fi === 'string') raw = fi;
          else if (fi && typeof fi === 'object') raw = fi.src || fi.url || '';
          if (!raw && p.images && p.images.length) {
            const first = p.images[0];
            raw = typeof first === 'string' ? first : ((first && (first.src || first.url)) || '');
          }
          if (!raw) return '';
          if (raw.indexOf('//') === 0) raw = 'https:' + raw;
          return raw + (raw.indexOf('?') > -1 ? '&' : '?') + 'width=280';
        };
        const esc = function (s) {
          return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        };

        fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            const products = (data.products || []).filter(function (p) { return p.available; });
            if (!products.length) return;
            let html = '<p class="wwp-cs-heading">Goes well with</p><div class="wwp-cs-grid">';
            products.slice(0, 3).forEach(function (p) {
              const imgSrc = pickSrc(p);
              /* Prices from this API are whole pence, but handle pound strings too */
              let priceNum = 0;
              if (typeof p.price === 'number') {
                priceNum = p.price / 100;
              } else {
                const v = String(((p.variants || [])[0] || {}).price || 0);
                priceNum = v.indexOf('.') !== -1 ? parseFloat(v) : parseFloat(v) / 100;
              }
              const price = (p.price_varies ? 'From ' : '') + '\u00a3' + priceNum.toFixed(2);
              html += '<a href="/products/' + esc(p.handle) + '" class="wwp-cs-card">';
              html += imgSrc
                ? '<img src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '" width="280" height="280" loading="lazy">'
                : '<div class="wwp-cs-img-placeholder"></div>';
              html += '<div class="wwp-cs-info"><span class="wwp-cs-title">' + esc(p.title) + '</span><span class="wwp-cs-price">' + price + '</span></div></a>';
            });
            html += '</div>';
            container.innerHTML = html;
          })
          .catch(function () {});
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();
        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();
        const modalDialogs = productElement.querySelectorAll('modal-dialog');
        if (modalDialogs) modalDialogs.forEach((el) => el.remove());
        /* Remove the large payment badges block above the title */
        const paymentBadges = productElement.querySelector('.payment-badges-block');
        if (paymentBadges) paymentBadges.remove();
        /* Remove the sticky ATC bar */
        const stickyAtc = productElement.querySelector('sticky-atc');
        if (stickyAtc) stickyAtc.remove();
        /* Remove product-recommendations sections */
        const complementary = productElement.querySelector('product-recommendations');
        if (complementary) complementary.remove();
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
        });
        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;
        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;
        let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        if (product.classList.contains('product--medium')) mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        else if (product.classList.contains('product--small')) mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
